<vb-ui-form-group labelClass="labelClass" [parentNgModel]="control">

	@if (label) {
		<label [id]="labelId" [ngClass]="isSmallLabel ? styles.smallLabel : ''" #uiLabel>
			{{label}}
		</label>
	}

	<div uiControl role="group">
		<div class="btn-file" [ngClass]="isSmallLabel ? styles.smallInput : ''" vbBtnPrimary fileUpload (onAdd)="setImageFile($event.file)">
			<span class="vb-icon vb-icon-center vb-icon-file"></span>
			{{ 'ChooseFile' | translate }}
			<input type="file" [attr.aria-labelledby]="labelId" [disabled]="isFileDisabled">
		</div>

		<div *ngIf="value?.url" [ngClass]="styles.imagePreview">
			<img [src]="value.url" [alt]="label || ''" vbImageLoad>
			<span *ngIf="!imageComponentMetadata.readOnly">
				<button type="button" *ngIf="imageComponentMetadata.showDeleteButton" (click)="clearSelectedImage()" vbBtnWhite>
					{{ 'Delete' | translate }}
				</button>
				<button type="button" *ngIf="imageComponentMetadata.showResetButton && value && !isDefaultImageSelected" (click)="setDefaultImage()" vbBtnWhite>
					{{ 'ResetDefault' | translate }}
				</button>
			</span>
		</div>
	</div>

	<div role="alert" uiValidation>
		<div *ngIf="control?.invalid" vbUiErrorMessage>

			@if (control.errors.required) {
				{{ 'ThisFieldIsRequired' | translate }}
			} @else if (control.errors.fileType) {
				{{ 'ImageSelector_FileExtensionError' | translate }}: {{ fileExtensions.join(', ') }}
			} @else if (control.errors.size) {
				{{ 'ImageSelector_SizeError' | translate : { '0': imageComponentMetadata.maxSize | fileSize } }}
			} @else if (control.errors.squareDimensions) {
				{{ 'ImageSelector_SquareDimensionsError' | translate }}
			}
		</div>
	</div>
</vb-ui-form-group>

